import { useSessionStore } from '@/stores'
import { cn, updateFontSizes } from '@utils'
import StepTitle from '@/components/StepTitle'

interface SessionContentProps {
  currentSession?: any
  session?: any
}

const SessionContent = ({ currentSession, session: sessionProp }: SessionContentProps) => {
  const storeSession = useSessionStore(s => s.session)

  const activeSession = currentSession ?? sessionProp ?? storeSession

  if (!activeSession) {
    return null
  }

  const isEnhancedContent = activeSession.enhanced_mode

  return (
    <StepTitle
      subtitle={
        !isEnhancedContent && activeSession.subtitle ? (
          <div
            dangerouslySetInnerHTML={{ __html: updateFontSizes(activeSession.subtitle) }}
            className="option rich-text"
          />
        ) : undefined
      }
      content={
        activeSession.content && activeSession.content.length ? (
          <div className="flex justify-center">
            <div
              className={cn('rich-text', !isEnhancedContent ? 'w-full md:w-10/12 lg:w-10/12 xl:w-10/12' : 'w-full')}
              dangerouslySetInnerHTML={{ __html: updateFontSizes(activeSession.content) }}
            />
          </div>
        ) : undefined
      }>
      {!isEnhancedContent && activeSession.label && (
        <div
          dangerouslySetInnerHTML={{ __html: updateFontSizes(activeSession.label) }}
          className="how-can label-content-width rich-text"
        />
      )}
    </StepTitle>
  )
}

export default SessionContent
